import React from 'react';
import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from 'react-router-dom';

import { Link, LinkProps } from './Link';

export type RouterLinkProps = {
  children?: LinkProps['children'];
  color?: LinkProps['color'];
  reloadDocument?: ReactRouterLinkProps['reloadDocument'];
  replace?: ReactRouterLinkProps['replace'];
  state?: ReactRouterLinkProps['state'];
  underline?: LinkProps['underline'];
  sx?: LinkProps['sx'];
  to: ReactRouterLinkProps['to'];
  variant?: LinkProps['variant'];
  onClick?: LinkProps['onClick'];
};

export const RouterLink = (props: RouterLinkProps) => {
  return <Link component={ReactRouterLink} {...props} />;
};
